/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { Ico } from './ShellIcons';
import pop from './popovers.module.css';

// ============================================================
// PortalSearch — the portal's own search field (the global one lives in the
// app bar). Immediate value in, the caller debounces (Convention #57). The
// focus panel holds the recent terms of THIS portal (localStorage, per
// browser) and "Filter by" shortcuts that open the matching filter popover —
// the honest form of a scoped search when the underlying search is one
// substring over fixed fields. Claims `/` on document (Convention #169).
// ============================================================

const MAX_RECENT = 5;
function readRecent(key) { try { const v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v.slice(0, MAX_RECENT) : []; } catch (e) { return []; } }
function writeRecent(key, list) { try { localStorage.setItem(key, JSON.stringify(list.slice(0, MAX_RECENT))); } catch (e) { /* session only */ } }

export default function PortalSearch({ scope, value, onChange, placeholder, portalName, filterBy = [], onFilterBy, kbd = '/', inputRef: extRef }) {
  const ownRef = useRef(null);
  const inputRef = extRef || ownRef;
  const wrap = useRef(null);
  const [focus, setFocus] = useState(false);
  const storeKey = `clb.shell.recent.${scope}`;
  const [recent, setRecent] = useState(() => readRecent(storeKey));

  const remember = (term) => {
    const t = (term || '').trim(); if (!t) return;
    const next = [t, ...recent.filter((x) => x !== t)].slice(0, MAX_RECENT);
    setRecent(next); writeRecent(storeKey, next);
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      const t = e.target && e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT' || (e.target && e.target.isContentEditable)) return;
      e.preventDefault(); e.stopPropagation();
      inputRef.current && inputRef.current.focus();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [inputRef]);

  return (
    <div className={`${pop.ps} ${focus ? pop.focus : ''}`} ref={wrap} data-ps data-focus={focus ? '1' : '0'} data-shell-pop onClick={(e) => e.stopPropagation()}>
      <Ico name="search" className={pop.ico} data-ico />
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setTimeout(() => { if (wrap.current && !wrap.current.contains(document.activeElement)) { setFocus(false); remember(value); } }, 120)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') { remember(value); setFocus(false); e.currentTarget.blur(); }
          if (e.key === 'Escape') { if (value) onChange(''); else { setFocus(false); e.currentTarget.blur(); } e.stopPropagation(); }
        }}
        placeholder={placeholder}
        aria-label={`Search ${portalName}`}
      />
      {value ? (
        <button type="button" className={pop.clr} aria-label="Clear search" onMouseDown={(e) => e.preventDefault()} onClick={() => { onChange(''); inputRef.current && inputRef.current.focus(); }}><Ico name="x" /></button>
      ) : <span className={pop.kbd} data-kbd>{kbd}</span>}
      {focus && (recent.length > 0 || filterBy.length > 0) && (
        <div className={pop.psPanel} onMouseDown={(e) => e.preventDefault()}>
          {recent.length > 0 && <>
            <div className={pop.fsec}>Recent</div>
            {recent.map((r) => (
              <button key={r} type="button" className={pop.psRow} onClick={() => { onChange(r); remember(r); }}>
                <Ico name="history" /><span className={pop.t}>{r}</span><span className={pop.k}>search</span>
              </button>
            ))}
          </>}
          {filterBy.length > 0 && <>
            <div className={pop.fsec}>Filter by</div>
            <div className={pop.psScope}>
              {filterBy.map((f) => (
                <button key={f.key} type="button" onClick={() => { setFocus(false); inputRef.current && inputRef.current.blur(); onFilterBy && onFilterBy(f.key); }}>
                  {f.icon && <Ico name={f.icon} />}{f.label}
                </button>
              ))}
            </div>
          </>}
          <div className={pop.psTip}><span>Type to search across {portalName}</span><span><kbd>↵</kbd> keep · <kbd>esc</kbd> clear</span></div>
        </div>
      )}
    </div>
  );
}
